export default __webpack_public_path__ + "static/media/logo.665ee452.png";